<div class="row container-collapse"
    [ngStyle]="{'margin-bottom': containerCollpaseMarginBottom}">
    <div class="col-12">
        <a class="collapse-title" (click)="toggleCollapse()" [title]="titleTooltip ? titleTooltip : ''"
            [ngStyle]="{
                'margin-top': collpaseTitleMarginTop,
                'margin-left': collpaseTitleMarginLeft,
                'margin-right': collpaseTitleMarginRight,
                'margin-bottom': collpaseTitleMarginBottom
            }">  
            <i class="fas fa-caret-down" aria-hidden="true" *ngIf="!isCollapsedIn"></i>
            <i class="fas fa-caret-up" aria-hidden="true" *ngIf="isCollapsedIn"></i>
            {{title}}
        </a>         

        <div class="row collapse-content" #collapseContent>
            <div class="col-12">
                <ng-content></ng-content>
            </div>
        </div>        
    </div>
</div>
